import { Request } from 'common/domain/models/request';

export default () => {
  return function (items, filters) {
    let filtered = [];
    const JUST_ONE_FILTER = filters.length === 1;
    const IS_EMPTY = filters.length === 0;
    items.filter((item) => {
      const  isVisibleByType = filters.some((filter)=>{
        return item.type.includes(filter) || item.type.includes('holiday');
      });
      const isVisibleByStatus = filters.some((filter)=>{
        if(filter == Request.STATUS.REQUESTED){
          return filter === item.status || item.status === Request.STATUS.DELETED || item.type.includes('holiday');
        }
        return filter === item.status || item.type.includes('holiday');
      });
      const isVisible = (isVisibleByType && JUST_ONE_FILTER ) || (isVisibleByStatus && JUST_ONE_FILTER) || (isVisibleByType && isVisibleByStatus) || IS_EMPTY ;

      if (isVisible) { filtered.push(item);}
    });
    return filtered;
  };
};



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/filters/periods.js